import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

/**
 * LeaderboardRow — humanizowany wiersz rankingu (sekcja 8.8).
 * Pozycja, awatar, nazwa, wynik, trend, marker własnego użytkownika.
 */
function LeaderboardRow({ position, name, avatarUrl, initials, score, scoreLabel, trend = 0, isCurrentUser = false }) {
  const theme = useTheme();

  const TrendIcon = trend > 0 ? TrendingUpIcon : trend < 0 ? TrendingDownIcon : TrendingFlatIcon;
  const trendColor = trend > 0 ? 'success.main' : trend < 0 ? 'error.main' : 'text.secondary';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        py: 1.5,
        px: 2,
        borderRadius: `${theme.tokens?.primitive?.radius?.control ?? 12}px`,
        bgcolor: isCurrentUser ? theme.tokens?.semantic?.surface?.brandTint ?? 'primary.50' : 'transparent',
        border: isCurrentUser ? `1px solid ${theme.palette.primary.main}40` : '1px solid transparent',
        transition: 'background-color 160ms ease',
        '&:hover': {
          bgcolor: isCurrentUser
            ? theme.tokens?.semantic?.surface?.brandTint
            : theme.palette.action.hover,
        },
      }}
    >
      <Typography
        variant="body2"
        sx={{ fontWeight: 700, minWidth: 28, textAlign: 'center', color: position <= 3 ? 'primary.main' : 'text.secondary' }}
      >
        {position}
      </Typography>
      <Avatar
        src={avatarUrl}
        sx={{ width: 36, height: 36, fontSize: '0.8rem', fontWeight: 700, bgcolor: 'primary.light', color: 'primary.main' }}
      >
        {initials || name?.charAt(0)}
      </Avatar>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {name}
          {isCurrentUser && (
            <Typography component="span" variant="caption" color="primary.main" sx={{ ml: 1, fontWeight: 700 }}>
              Ty
            </Typography>
          )}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
          {score}
        </Typography>
        {scoreLabel && (
          <Typography variant="caption" color="text.secondary">
            {scoreLabel}
          </Typography>
        )}
      </Box>
      <TrendIcon sx={{ fontSize: 18, color: trendColor }} />
    </Box>
  );
}

export default LeaderboardRow;
